export default __webpack_public_path__ + "static/media/retain1.15cc9f28.svg";